<template>
    <div class="frame-component">
        <div class="app-table-container body-wrap">
            <el-row :gutter="20">
                <el-col :span="12">
                    <DataTable
                    tableId="table-first"
                    :tableProps="selectedProps"
                    :tableData="selectedData"
                    :tableTitle="$t('content.store.framePreview')"
                    @tableHandle="selectedHandle"
                    >
                    <!-- <pagination
                    layout="prev, pager, next"
                    :pageSize='selectedParams.limit'
                    :total="selectedTotal"
                    @pageNum="selectPageNum"                            
                    /> -->
                    </DataTable>
                </el-col>
                <el-col :span="12">
                    <DataTable
                    tableId="table-second"
                    :tableProps="selectableProps"
                    :tableData="selectableData"
                    @tableHandle="selectableHandle"
                    >
                    <!-- <pagination
                    layout="prev, pager, next"
                    :pageSize='selectableParams.limit'
                    :total="selectableTotal"
                    @pageNum="selectablePageNum"
                    /> -->
                    </DataTable>
                </el-col>
            </el-row>
        </div>
        <div class="footer-wrap">
            <button class="global-button-style">{{$t('commonMsg.save')}}</button>
        </div>      
    </div>
</template>

<script>
import DataTable from '@/components/dataTable'
export default {
    components: {
        DataTable
    }, 
    computed: {
        selectedProps() {
            const selectedProps = [{
                prop: 'name',
                label: this.$t('content.store.permission')
            },{
                prop: 'handle',
                label: this.$t('commonMsg.handle'),
                width: 80,
                btn: [this.$t('commonMsg.del')]
            }]
            return selectedProps
        },
        selectableProps() {
            const selectableProps = [{
                prop: 'name',
                label: this.$t('content.store.permission')
            },{
                prop: 'handle',
                label: this.$t('commonMsg.handle'),
                width: 80,
                btn: [this.$t('commonMsg.add')]
            }]

            return selectableProps
        }
    },
    data() {
        return {           
            selectedData: [
                {
                    name: 'df'                    
                },
                {
                    name: 'df'                    
                },
                {
                    name: 'df'                    
                },
                {
                    name: 'df'                    
                },
                {
                    name: 'df'                    
                },
                {
                    name: 'df'                    
                },
                {
                    name: 'df'                    
                },
                {
                    name: 'df'                    
                },
                {
                    name: 'df'                    
                },
                {
                    name: 'df'                    
                },
                {
                    name: 'df'                    
                },
                {
                    name: 'df'                    
                },                                                                                                                                                                                
            ],
            selectableData: [],
            selectedTotal: 0,
            selectableTotal: 0,
            selectedParams: {limit: 20, offset: 0},
            selectableParams: {limit: 20, offset: 0}
        }
    }, 
    methods: {
        selectedHandle(value){
            this.selectedData.splice(value.data.$index, 1)
            this.selectableData = [...this.selectableData, value.data.row]
        },   
        selectableHandle(value){
            // let isTure = this.selectedData.some(item => value.data.row.id === item.id)
            this.selectableData.splice(value.data.$index, 1)
            this.selectedData = [...this.selectedData, value.data.row]
        }             
    },      
    created() {
    }
}
</script>

<style lang="scss">
    .frame-component{    
        flex: 1;
        display: flex;
        flex-direction: column;
        .header-wrap{
            // min-height: 200px;
            .app-table-container{
                margin-bottom: 0;
            }
        }
        .body-wrap{
            flex: 1;
        }
        .footer-wrap{
            margin-bottom: 20px;
            text-align: center;
        }
    }
</style>